import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from '../../store/authSlice'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * 인증 가드.
 * - 로그인 상태가 아니면 `/login?from=<현재경로>` 로 리다이렉트한다.
 * - 로컬 개발 시 인증을 우회하고 싶으면 `VITE_BYPASS_AUTH=true` 환경변수를
 *   `.env.local` 에 설정한다. 기본값은 false — DEV 모드라도 로그인 필수.
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const location = useLocation()

  const bypass = import.meta.env.VITE_BYPASS_AUTH === 'true'

  if (!isAuthenticated && !bypass) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
